import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import MedicineModal from "./MedicineModal";
import LabModal from "./LabModal";
import { Dialog } from "primereact/dialog";
import http from "../../../src/Redux/services/http-common.jsx";
import { Toast } from "primereact/toast";

function SidebarEprescription({ scheduledata, closeFun }) {
  const toast = useRef(null);
  const {
    document,
    firstName,
    lastName,
    mobile,
    patientCode,
    documentType,
    title,
    gender,
    dob,
  } = scheduledata;
  
  // Calculate age from date of birth
  const calculateAge = (dob) => {
    if (!dob) return "";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const patientAge = dob ? calculateAge(dob) : "";
  
  // Format gender: F -> Female, M -> Male
  const formatGender = (genderValue) => {
    if (!genderValue) return "";
    const upperGender = genderValue.toUpperCase();
    if (upperGender === "F") return "Female";
    if (upperGender === "M") return "Male";
    return genderValue; // Return as-is if already formatted or unknown
  };

  const formattedGender = gender ? formatGender(gender) : "";
  
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [editingRowIndex2, setEditingRowIndex2] = useState(null);
  const [editingMedicineData, setEditingMedicineData] = useState(null);
  let parsedData = null;
  let scheduleFollowupData = {};
  let selectedFollowup = "";
  let testedOnFormatted = "";
  const [loading, isLoading] = useState(false);
  if (scheduledata?.smartDoc) {
    try {
      parsedData = JSON.parse(scheduledata.smartDoc);
      console.log(parsedData, "rftgyhujiokplp");
      scheduleFollowupData = parsedData[0].data.schedule_followup || {};
      selectedFollowup = scheduleFollowupData.after_1_week
        ? "after_1_week"
        : scheduleFollowupData.after_15_days
        ? "after_15_days"
        : scheduleFollowupData.after_1_month
        ? "after_1_month"
        : "";

      const convertToInputDateFormat = (dateStr) => {
        const [day, month, year] = dateStr.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      };

      testedOnFormatted = convertToInputDateFormat(
        parsedData[0].data.patient_details.tested_on
      );
    } catch (err) {
      console.error("Error parsing smartDoc:", err);
    }
  }
  console.log(scheduledata.smartDoc, "esdrtfyguhijo");

  const [formData, setFormData] = useState(() => {
    if (parsedData) {
      return {
        chiefComplaint: parsedData[0]?.data?.chiefComplaint || "",
        doctor: parsedData[0]?.data?.patient_details?.ref_doctor || "",
        date: testedOnFormatted,
        primary: parsedData[0]?.data?.diagnosis?.primary || "",
        primaryICD: "",
        secondary: parsedData[0]?.data?.diagnosis?.secondary || "",
        secondaryICD: "",
        symptoms: parsedData[0]?.data?.symptoms,
        recommendation: parsedData[0]?.data?.recommendation,
        schedule_followup: selectedFollowup,
        medicine_details: parsedData[0]?.data?.medicine_details || [],
        lab_test_details: {
          tests: parsedData[0]?.data?.lab_test_details?.tests || [],
        },
      };
    } else {
      return {
        chiefComplaint: "",
        doctor: "",
        date: "",
        primary: "",
        primaryICD: "",
        secondary: "",
        secondaryICD: "",
        symptoms: "",
        recommendation: "",
        schedule_followup: "",
        medicine_details: [],
        lab_test_details: {
          tests: [],
        },
      };
    }
  });
  console.log(parsedData, "parsedData");
  const [primaryOptions, setPrimaryOptions] = useState([]);
  const [icdCodeOptions, setIcdCodeOptions] = useState([]);
  const [secondaryOptions, setSecondary] = useState([]);
  const [submitData, setSubmitData] = useState({
    patientDrugPrescriptionList: [],
    patientLabTestsList: [],
  });
  const [activeModal, setActiveModal] = useState(null);



  const handleMedicineData = (data) => {
    console.log(data, editingRowIndex, "sedrtfyguhijko");
    const newMedicine = Array.isArray(data) ? data[0] : data;

    setFormData((prev) => {
      const updatedList = [...prev.medicine_details];

      if (editingRowIndex !== null) {
   
        updatedList[editingRowIndex] = newMedicine;
      } else {
        // Add new item
        updatedList.push(newMedicine);
      }

      return {
        ...prev,
        medicine_details: updatedList,
      };
    });

    setEditingRowIndex(null);
    setActiveModal(null);
  };

  const handleLabData = (data) => {
    console.log(data, "derfgthnj");
  
    const newTests = Array.isArray(data) ? data : [data];
  
    setFormData((prev) => {
      const currentTests = prev.lab_test_details?.tests || [];
      const updatedTests = [...currentTests];
  
      if (editingRowIndex2 !== null) {
        // Edit specific index if in edit mode
        updatedTests[editingRowIndex2] = newTests[0]; // only one in edit
      } else {
        // Append all new tests
        newTests.forEach((test) => {
          updatedTests.push(test);
        });
      }
  
      return {
        ...prev,
        lab_test_details: {
          ...prev.lab_test_details,
          tests: updatedTests,
        },
      };
    });
  
    setEditingRowIndex2(null);
    setActiveModal(null);
  };
  
 console.log(formData, "formDatadcfgvbh");
  useEffect(() => {
    const fetchPrimaryOptions = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_DOC_URL}Diagnosis/list?termSetId=ICD10&codeLevel=1&status=1`
        );

        if (response.data && Array.isArray(response.data)) {
          const options = response?.data?.map((item) => ({
            label: item.description,
            value: item.description,
            termCode: item.termCode,
          }));
          setPrimaryOptions(options);
          setSecondary(options);
        }
      } catch (error) {
        console.error("Error fetching primary dropdown options:", error);
      }
    };

    fetchPrimaryOptions();
  }, []);

  const handleIcdDropdownChange = (e) => {
    setFormData({
      ...formData,
      primaryICD: e.value,
    });
  };
  const handleDropdownChange = (e) => {
    const selectedPrimary = primaryOptions.find(
      (item) => item.value === e.value
    );

    setFormData({
      ...formData,
      primary: selectedPrimary.value,
      primaryICD: selectedPrimary.termCode,
    });
  };
  const handleDropdownChangesecondary = (e) => {
    const selectedSecondary = secondaryOptions?.find(
      (item) => item.value === e.value
    );

    setFormData({
      ...formData,
      secondary: selectedSecondary.value,
      secondaryICD: selectedSecondary.termCode,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    isLoading(true);
    try {
      const baseData = parsedData?.[0]?.data || {};
      const patient_details = parsedData?.[0]?.data?.patient_details || {};
      
      const updatedSmartDocData = {
        ...baseData,
        chiefComplaint: formData?.chiefComplaint || "",
        symptoms: formData?.symptoms || "",
        recommendation: formData?.recommendation || "",
        diagnosis: {
          primary: formData?.primary || "",
          secondary: formData?.secondary || "",
        },
        schedule_followup: {
          after_1_week: formData?.schedule_followup === "after_1_week",
          after_15_days: formData?.schedule_followup === "after_15_days",
          after_1_month: formData?.schedule_followup === "after_1_month",
        },
        patient_details: {
          ...patient_details,
          name: firstName && lastName ? `${firstName} ${lastName}` : patient_details?.name || "",
          gender: formattedGender || formatGender(patient_details?.gender) || "",
          age: patientAge || patient_details?.age || "",
          ref_doctor: formData?.doctor || "",
          tested_on: formData?.date || "",
        },
        medicine_details: formData?.medicine_details || [],
        lab_test_details: {
          tests: formData?.lab_test_details?.tests || [],
        },
      };

      const payload = {
        id: scheduledata?.id || null,
        patientCode: scheduledata?.patientCode || null,
        smartDoc: { data: updatedSmartDocData },
        // smartDoc: {
        //   data: {
        //     firstName: scheduledata.firstName || null,
        //     lastName: scheduledata.lastName || null,
        //     mobile: scheduledata.mobile || null,

        //     ePrescriptionGen: 1,
        //     updateePrescriptionStatus: 1,
        //     ePrescriptionStatus: 1,
        //     documentReceivedSource: scheduledata.documentReceivedSource || null,
        //     docName: formData.doctor,
        //     chiefComplaint: formData?.chiefComplaint,
        //     primaryDiagnosis: formData.primary || null,
        //     primarySymptoms: formData.primaryICD || null,
        //     recommendation: formData.recommendation || null,
        //     secondaryDiagnosis: formData.secondary || null,
        //     secondarySymptoms: formData.secondaryICD || null,
        //     symptoms: formData.symptoms || null,
        //     visitDate: formData.date || null,
        //     patientDrugPrescriptionList:
        //       submitData.patientDrugPrescriptionList?.map((item) => ({
        //         code: item?.code || null,
        //         composition: item.composition || null,
        //         afterBeforeFood: item?.duration || null,
        //         type: item.type || null,
        //         drugName: item.name || null,
        //         dosage: item?.dosage || null,
        //         quantity: item?.quantity || null,
        //         instuction: item?.instructions || null,
        //       })) || [],
        //     patientLabTestsList:
        //       submitData.patientLabTestsList?.map((test) => ({
        //         labTestId: test.code || null,
        //         labTestName: test.label || null,
        //         name: test.value || null,
        //       })) || [],
        //   },
        // },
        modifiedBy: "rcFIA2639p",

        status: 1,
        smartReportStatus: 1,
        isVerified: 1,
      };
      console.log(payload, "fghjklgvhjk");
      const response = await http.put(
        `${process.env.REACT_APP_BASEURL}PatientDocument/updatePrescription`,
        payload
      );
      console.log(response, "sedrtfgyh");
      if (response.status === 200) {
        // Call sync-smartdoc API after successful update
        try {
          const syncResponse = await http.get(
            `${process.env.REACT_APP_EPRESCRIPTION}patient-document/sync-smartdoc?id=${scheduledata?.id || payload.id}`
          );
          console.log(syncResponse, "sync-smartdoc response");
        } catch (syncError) {
          console.error("Error syncing smartdoc:", syncError);
          // Don't block the success flow if sync fails
        }
        
        isLoading(false);
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Prescription submitted successfully!",
        });
        setTimeout(() => {
          closeFun();
        }, 2000);
      } else {
        isLoading(false);
        toast.current.show({
          severity: "warn",
          summary: "Failed",
          detail: "Unable to submit prescription.",
        });
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      isLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message || error?.message || "Something went wrong while submitting prescription.",
      });
    }
  };


  const handleFollowupChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      schedule_followup: value,
    }));
  };
  const handleDeleteMedicine = (indexToDelete) => {
    setFormData((prev) => ({
      ...prev,
      medicine_details: prev.medicine_details.filter(
        (item, index) => index !== indexToDelete
      ),
    }));
  };
  const handleDeleteLabTest = (indexToDelete) => {
    setFormData((prev) => ({
      ...prev,
      lab_test_details: {
        ...prev.lab_test_details,
        tests: prev.lab_test_details.tests.filter(
          (test, index) => index !== indexToDelete
        ),
      },
    }));
  };


  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Toast ref={toast} />
      <button
        onClick={closeFun}
        style={{
          alignSelf: "flex-end",
          marginBottom: "10px",
          background: "red",
          color: "white",
          border: "none",
          borderRadius: "4px",
          padding: "5px 10px",
          cursor: "pointer",
        }}
      >
        Close
      </button>

      <div style={{ display: "flex", gap: "20px" }}>
        {/* Uploaded Prescription Section */}
        <div
          style={{
            flex: 1,
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            backgroundColor: "#f9f9f9",
          }}
        >
          <h3>Uploaded Manual Prescription</h3>
          {document?.toLowerCase().endsWith(".pdf") ? (
            <iframe
              src={scheduledata.originalDoc} // Use originalDoc URL for PDFs
              style={{
                width: "100%",
                height: "500px",
                borderRadius: "8px",
                marginTop: "10px",
              }}
              title="Prescription PDF"
            ></iframe>
          ) : (
            <img
              src={scheduledata.originalDoc} // Use originalDoc for the actual image URL
              alt="Prescription Document"
              style={{
                maxWidth: "100%",
                borderRadius: "8px",
                marginTop: "10px",
              }}
            />
          )}
        </div>

        {/* e-Prescription Section */}
        <div
          style={{
            flex: 1,
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            backgroundColor: "#f9f9f9",
          }}
        >
          <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
            Convert Manual Prescription to e-Prescription
          </h3>
          <div style={{ marginBottom: "10px" }}>
            <strong>Patient:</strong>{" "}
            {firstName && lastName ? `${firstName} ${lastName}` : parsedData ? parsedData[0].data.patient_details?.name : ""}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <strong>Mobile:</strong> {mobile}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <strong>Patient Code:</strong> {patientCode}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <strong>Age:</strong>{" "}
            {patientAge || (parsedData ? parsedData[0].data.patient_details?.age : "")}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <strong>Gender:</strong>{" "}
            {formattedGender || (parsedData ? formatGender(parsedData[0].data.patient_details?.gender) : "")}
          </div>

          <form onSubmit={(e) => e.preventDefault()}>
            <div style={{ marginBottom: "10px" }}>
              <label>Chief Complaint</label>
              <input
                type="text"
                name="chiefComplaint"
                value={formData.chiefComplaint}
                onChange={handleInputChange}
                style={{
                  width: "100%",
                  padding: "8px",
                  marginTop: "5px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
              <div style={{ flex: 1 }}>
                <label>Doctor</label>
                <input
                  type="text"
                  name="doctor"
                  value={formData.doctor}
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label>Date</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
              <div style={{ flex: 1 }}>
                <label>Primary Diagnosis</label>
                <input
                  type="text"
                  name="primary"
                  value={formData?.primary}
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>

              <div style={{ flex: 1 }}>
                <label>Secondary Diagnosis</label>
                <input
                  type="text"
                  name="secondary"
                  value={formData?.secondary}
                  onChange={handleInputChange}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            </div>

            {/* <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
              <div style={{ flex: 1 }}>
                <label>Primary</label>
                <Dropdown
                  value={formData?.primary}
                  options={primaryOptions}
                  onChange={handleDropdownChange}
                  placeholder="Select Primary"
                  style={{
                    width: "100%",
                    marginTop: "5px",
                  }}
                  panelStyle={{
                    maxWidth: "100%",
                  }}
                  scrollHeight="200px"
                />
              </div>
              <div style={{ flex: 1 }}>
                <label>ICD-10 Code</label>
                <input
                  type="text"
                  value={formData.primaryICD}
                  readOnly
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    background: "#f5f5f5",
                  }}
                />
              </div>
            </div> */}

            {/* <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
              <div style={{ flex: 1 }}>
                <label>Secondary</label>
                <Dropdown
                  value={formData?.secondary}
                  options={secondaryOptions}
                  onChange={handleDropdownChangesecondary}
                  placeholder="Select Secondary"
                  style={{
                    width: "100%",
                    marginTop: "5px",
                  }}
                  panelStyle={{
                    maxWidth: "100%",
                  }}
                  scrollHeight="200px"
                />
              </div>
              <div style={{ flex: 1 }}>
                <label>ICD-10 Code</label>
                <input
                  type="text"
                  value={formData.secondaryICD}
                  readOnly
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    background: "#f5f5f5",
                  }}
                />
              </div>
            </div> */}

            <div style={{ marginBottom: "10px" }}>
              <label>Symptoms</label>
              <input
                type="text"
                name="symptoms"
                value={formData.symptoms}
                onChange={handleInputChange}
                style={{
                  width: "100%",
                  padding: "8px",
                  marginTop: "5px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ marginBottom: "10px" }}>
              <label>Recommendation</label>
              <textarea
                name="recommendation"
                value={formData.recommendation}
                onChange={handleInputChange}
                style={{
                  width: "100%",
                  padding: "8px",
                  marginTop: "5px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            </div>
            <div style={{ marginBottom: "10px" }}>
              <label>Schedule For Follow Up</label>
              <div style={{ marginTop: "5px" }}>
                <label>
                  <input
                    type="radio"
                    name="schedule_followup"
                    value="after_1_week"
                    checked={formData.schedule_followup === "after_1_week"}
                    onChange={(e) => handleFollowupChange(e.target.value)}
                  />
                  After 1 Week
                </label>
                <br />
                <label>
                  <input
                    type="radio"
                    name="schedule_followup"
                    value="after_15_days"
                    checked={formData.schedule_followup === "after_15_days"}
                    onChange={(e) => handleFollowupChange(e.target.value)}
                  />
                  After 15 Days
                </label>
                <br />
                <label>
                  <input
                    type="radio"
                    name="schedule_followup"
                    value="after_1_month"
                    checked={formData.schedule_followup === "after_1_month"}
                    onChange={(e) => handleFollowupChange(e.target.value)}
                  />
                  After 1 Month
                </label>
              </div>
            </div>
            {formData.medicine_details &&
              formData.medicine_details.length > 0 && (
                <div style={{ marginBottom: "10px" }}>
                  <label
                    style={{
                      fontWeight: "bold",
                      display: "block",
                      marginBottom: "10px",
                    }}
                  >
                    Medicine Details
                  </label>

                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ backgroundColor: "#f0f0f0" }}>
                        <th
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Medicine Name
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Dosage
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Instructions
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Duration (days)
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Quantity
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Type
                        </th>
                        {/* <th
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Notes
                        </th> */}
                        <th
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Edit
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                            textAlign: "left",
                            fontWeight: "bold",
                          }}
                        >
                          Delete
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.medicine_details &&
                        formData.medicine_details?.map((item, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {item.name}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {item.dosage}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {item.instructions}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {item.duration}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {item.quantity}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {item.type}
                            </td>
                            {/* <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                              }}
                            >
                              {item.notes}
                            </td> */}
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                              }}
                            >
                              <i
                                className="fa fa-pencil-square-o"
                                aria-hidden="true"
                                onClick={() => {
                                  setEditingRowIndex(index); 
                                  setActiveModal("medicine");
                                  setEditingMedicineData(item); 
                                }}
                                style={{ cursor: "pointer" }}
                              ></i>
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                              }}
                            >
                              <i
                                className="fa fa fa-trash-o"
                                aria-hidden="true"
                                onClick={() => handleDeleteMedicine(index)}
                                style={{ cursor: "pointer", color: "red" }}
                              ></i>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            {/* {parsedData[0].data.lab_test_details.tests.length > 0 ? ( */}
            {formData && formData?.lab_test_details?.tests?.length > 0 ? (
              <div style={{ marginBottom: "10px" }}>
                <label
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    marginBottom: "10px",
                  }}
                >
                  LabTest Details
                </label>

                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ccc",
                          textAlign: "left",
                          fontWeight: "bold",
                        }}
                      >
                        Test Name
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ccc",
                          textAlign: "left",
                          fontWeight: "bold",
                        }}
                      >
                        Edit
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ccc",
                          textAlign: "left",
                          fontWeight: "bold",
                        }}
                      >
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData?.lab_test_details?.tests?.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                          }}
                        >
                          {item?.label}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ccc",
                          }}
                        >
                          <i
                            className="fa fa-pencil-square-o"
                            aria-hidden="true"
                            onClick={() => {
                              setEditingRowIndex2(index); // Save index
                              setActiveModal("lab"); // Open modal
                            }}
                            style={{ cursor: "pointer" }}
                          ></i>
                        </td>
                        <td>
                          <i
                            className="fa fa-trash-o"
                            aria-hidden="true"
                            onClick={() => handleDeleteLabTest(index)}
                            style={{ cursor: "pointer", color: "red" }}
                          ></i>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              {/* {!parsedData ||
              parsedData[0].data.medicine_details.length === 0 ? ( */}
              <button
                type="button"
                onClick={() => setActiveModal("medicine")} // Open Medicine Modal
                style={{
                  background: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  padding: "10px 20px",
                  cursor: "pointer",
                }}
              >
                Add Medicine
              </button>
              {/* ) : (
                ""
              )} */}
              {/* {parsedData?.[0]?.data?.lab_test_details?.tests?.length === 0 ||
              !parsedData ? ( */}
              <button
                type="button"
                onClick={() => setActiveModal("lab")} // Open Lab Modal
                style={{
                  background: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  padding: "10px 20px",
                  cursor: "pointer",
                }}
              >
                Add Lab Test
              </button>
              {/* ) : (
                ""
              )} */}
            </div>

            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <button
                type="button"
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  background: loading ? "gray" : "blue",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  padding: "10px 20px",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.7 : 1,
                }}
              >
                {loading ? "Loading..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* <Dialog
        header="Add Medicine"
        visible={activeModal === "medicine"}
        onHide={() => setActiveModal(null)}
      >
        <MedicineModal
          onClose={() => setActiveModal(null)}
          setMedicineData={handleMedicineData}
          
        />
      </Dialog> */}

<Dialog
  header="Add Medicine"
  visible={activeModal === "medicine"}
  onHide={() => {
    setActiveModal(null);
    setEditingRowIndex(null);          
    setEditingMedicineData(null);      
  }}
>
  <MedicineModal
    onClose={() => {
      setActiveModal(null);
      setEditingRowIndex(null);        
      setEditingMedicineData(null);    
    }}
    setMedicineData={handleMedicineData}
    initialData={editingMedicineData}
  />
</Dialog>


      {/* Lab Modal */}
      <Dialog
        header="Add Lab Test"
        visible={activeModal === "lab"}
        onHide={() => setActiveModal(null)}
      >
        <LabModal
          onClose={() => setActiveModal(null)}
          setLabData={handleLabData}
        />
      </Dialog>
    </div>
  );
}

export default SidebarEprescription;
